{
  "dismiss": "關閉"
}